<template>
  <div>
    <div v-if="forConasi" class="fixed-bottom text-right">
      <div class="alignleft">
        <span class="font-weight-light copyright">
          Copyrights &copy; {{ new Date().getFullYear() }} by
          <a href="https://conasi365.vn/" target="_blank">CONASI</a>
        </span>
      </div>
      <div class="alignright">
        <div
          class="text-center">
          <span>
            <a
              style="color: #eaefeb;"
              href="https://conasi365.vn/pages/chinh-sach-bao-mat"
              target="_blank">{{ $t('common.privacyPolicy') }}</a> |
            <a
              style="color: #eaefeb;"
              href="https://conasi365.vn/pages/chinh-sach-giai-quyet-khieu-nai"
              target="_blank">{{ $t('common.termsCondition') }}</a></span>
        </div>
      </div>
      <!-- <div v-if="forConasi" class="alignright">
        <span class="font-weight-light copyright">
          <a href="https://conasi365.vn/pages/chinh-sach-bao-mat" target="_blank">
            Chính sách bảo mật
          </a>
        </span>
        <span class="font-weight-light copyright">
          <a
            href="https://conasi365.vn/pages/chinh-sach-giai-quyet-khieu-nai"
            target="_blank"
          >
            Chính sách Giải quyết Khiếu nại
          </a>
        </span>
        <span class="font-weight-light copyright">
          <a href="https://conasi365.vn/pages/quy-che-hoat-dong" target="_blank">
            Quy chế Hoạt động
          </a>
        </span>
      </div> -->
      <div style="clear: both"></div>
    </div>
    <div v-else class="navbar-fixed-bottom">
      <div class="container">
        <div class="row">
          <div class="col-sm">
            <div class="header-text">
              <span>{{ $t('footer.contact') }}</span>
            </div>
            <div class="company-address">
              <i class="fas fa-building mr-1 mt-1" /><span> {{ company.name }}</span>
            </div>
            <div class="company-address">
              <i class="fas fa-map-marker mr-1 mt-1" /><span> {{ company.address }}</span>
            </div>
            <div v-if="company.email" class="company-address">
              <a :href="`mailto:${company.email}`"><i class="fas fa-envelope mr-1 mt-1" /> {{ company.email }}</a>
            </div>
            <div v-if="company.hotline" class="company-address">
              <a :href="`tel:${company.hotline}`"><i class="fas fa-phone mr-1 mt-1" /> {{ company.hotline }}</a>
            </div>
          </div>
          <div class="v-line d-flex" />
          <div class="col-sm">
            <div class="header-text">
              <span>{{ $t('footer.mobileApp') }}</span>
            </div>
            <div class="ml-4 mb-1">
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.avatarsolutions.evouchers"><img src="../assets/store_googleplay.png" height="28px" /></a>
            </div>
            <div class="ml-4 mb-1">
              <a target="_blank" href="https://apps.apple.com/us/app/evouchers/id1545109965"><img src="../assets/store_apple.png" height="28px" /></a>
            </div>
          </div>
          <div class="v-line d-flex" />
          <div class="col-sm">
            <div class="header-text">
              <span>{{ $t('footer.connectUs') }}</span>
            </div>
            <div class="ml-4">
              <a target="_blank" :href="`${company.facebook}`"><i class="fab fa-facebook mx-1" /> </a>
              <!-- <i class="fab fa-google mx-1" /> -->
            </div>
          </div>
          <div class="v-line d-flex" />
          <div class="col-sm">
            <!-- <div class="header-text">
              <span>{{ $t('footer.introduction') }}</span>
            </div> -->
            <!-- <a target="_blank" href="http://online.gov.vn/Home/WebDetails/82782"><img src="../assets/logoSaleNoti.png" height="48px" /></a> -->
            <a target="_blank" href="http://online.gov.vn/Home/WebDetails/89469"><img src="../assets/logoSaleNoti.png" height="48px" /></a>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="font-weight-light copyright">
          Copyrights &copy; {{ new Date().getFullYear() }} by
          <a href="https://www.avatarnext.com/" target="_blank">
            Avatar Technologies
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import stringUtils from 'Utils/stringUtils'
import { FOR_CONASI_TARGET } from 'Utils/constants'

export default {
  data: () => ({
    forConasi: FOR_CONASI_TARGET,
    company: {
      name: null,
      address: null,
      email: null,
      phone: null,
      facebook: null
    },
    objectSettingKey: stringUtils.ObjectSettingKey,
  }),
  created () {
    this.getCompanyName()
    this.getCompanyAddr()
    this.getCompanyHotline()
    this.getCompanyEmail()
    this.getCompanyFacebook()
  },
  methods: {
    /**
     * Get company setting info
     */
    getCompanyName: function () {
      let filter = {
        params: {
          getWithKey: true,
          key: this.objectSettingKey.COMPANY_NAME
        }
      }
      this.GET_OBJECT_SETTING(filter).then(
        function (res) {
          let data = res.data.data
          if (data.length !== 0) {
            this.company.name = data[0].value
          }
        }.bind(this)
      )
    },
    getCompanyAddr: function () {
      let filter = {
        params: {
          getWithKey: true,
          key: this.objectSettingKey.COMPANY_ADDRESSS
        }
      }
      this.GET_OBJECT_SETTING(filter).then(
        function (res) {
          let data = res.data.data
          if (data.length !== 0) {
            this.company.address = data[0].value
          }
        }.bind(this)
      )
    },
    getCompanyEmail: function () {
      let filter = {
        params: {
          getWithKey: true,
          key: this.objectSettingKey.COMPANY_EMAIL
        }
      }
      this.GET_OBJECT_SETTING(filter).then(
        function (res) {
          let data = res.data.data
          if (data.length !== 0) {
            this.company.email = data[0].value
          }
        }.bind(this)
      )
    },
    getCompanyHotline: function () {
      let filter = {
        params: {
          getWithKey: true,
          key: this.objectSettingKey.COMPANY_HOTLINE
        }
      }
      this.GET_OBJECT_SETTING(filter).then(
        function (res) {
          let data = res.data.data
          if (data.length !== 0) {
            this.company.hotline = data[0].value
          }
        }.bind(this)
      )
    },
    getCompanyFacebook: function () {
      let filter = {
        params: {
          getWithKey: true,
          key: this.objectSettingKey.COMPANY_FACEBOOK
        }
      }
      this.GET_OBJECT_SETTING(filter).then(
        function (res) {
          let data = res.data.data
          if (data.length !== 0) {
            this.company.facebook = data[0].value
          }
        }.bind(this)
      )
    },
    ...mapActions(['GET_OBJECT_SETTING'])
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/color.scss";
.fixed-bottom {
  color: white;
  background-color: #ff6d6d;
  padding: 4px 10px 4px 10px;
  font-size: 12px;
}
.alignleft {
  float: left;
}
.alignright {
  float: right;
}

a:link,
a:active,
a:hover,
a:visited {
  color: $btn-background;
}
.navbar-fixed-bottom {
  color: $btn-background;
  padding: 4px 10px 4px 10px;
  font-size: 13px;
}
.header-text {
  font-weight: 600 !important;
  padding-bottom: 3px;
}
.company-address {
  display: flex;
}
.v-line {
  width: 1px;
  background-color: lightgray;
}
@media (max-width: 575px) {
  .v-line {
    width: 100%;
    height: 1px;
    margin: 5px 1em;
  }
}
</style>